function nearestStrike(rawStrike, price) {
  const p = Number(price || 0);

  let interval = 1;
  if (p >= 500) interval = 5;
  else if (p >= 100) interval = 2.5;
  else if (p >= 25) interval = 1;
  else interval = 0.5;

  return Math.round(rawStrike / interval) * interval;
}

export function suggestedStrike(r) {
  const price = Number(r.price || 0);
  if (!price || !r.bias || r.bias === "WAIT") return "-";

  if (r.bias === "CALL") {
    const raw = price * 1.0357;
    return `${nearestStrike(raw, price)}C`;
  }

  if (r.bias === "PUT") {
    const raw = price * 0.9643;
    return `${nearestStrike(raw, price)}P`;
  }

  return "-";
}

export function suggestedDte(r) {
  const opportunity = Math.abs(Number(r.recovery_3d_expansion_room_pct || 0));
  const score = Number(r.msi_score || 0);

  if (opportunity < 2) return "No trade";
  if (score >= 85 && opportunity >= 8) return "30-45D";
  if (opportunity >= 5) return "21-30D";
  return "14-21D";
}

export function contractLabel(r) {
  const strike = suggestedStrike(r);
  const dte = suggestedDte(r);

  if (strike === "-" || dte === "No trade") return "No trade";

  return `${strike} · ${dte}`;
}
